import React, { useEffect, useState } from "react";
import Fade from "react-reveal/Fade";
import ic_tick from "../../assets/icons/ic_check.svg";
import fitnessAgeImage from "../../assets/images/FitnessAgeImage.png";
import cardioHealth from "../../assets/images/cardioHealthImg.png";
import fitness_age1 from "../../assets/images/fitness_age1.png";
import AuthDialog from "../auth/AuthDialog";
// import { HealthyLife } from "../discovery/LandingPage";
import { useNavigate } from "react-router-dom";
import headerImage from "../../assets/images/HeaderImage.png";
import useIsMobile from "../../utils/useIsMobile";
// import { QuickStretches } from "./QuickStretches";
import { Dialog, Transition } from "@headlessui/react";
import { Icon } from "@iconify/react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import {
  getIpDetials,
  postCreateLead,
  sendMobileOtp,
  verifyMobileOtp,
} from "../../api/api";
import ic_close from "../../assets/icons/ic_close.svg";
import ic_playlist from "../../assets/icons/ic_playlist_white.svg";
import { validPhone } from "../../utils/Utils";
import Button from "../basic/Button";
import CustomDialog from "../basic/Dialog";
import IconButton from "../basic/IconButton";
import OtpInput from "../basic/OtpInput";
import InstructionDialog from "../home/InstructionDialog";
// import { GetactyvStats } from "../discovery/LandingPage";
import perfect_vision_logo from "../../assets/images/perfect_vision_logo.png";
import { StartFreeTrail, TestimonialSection } from "../discovery/LandingPage";

// Sub-Header
export function Header({ openAuth }) {
  const Indicator = ({ text, showLine, number }) => (
    <div className={`flex flex-col w-full `}>
      <div className="flex flex-row w-full items-center">
        <div
          className={`flex items-center justify-center rounded-full h-[60px] w-[60px] p-1 bg-white bg-opacity-5 `}
        >
          <div
            className={`flex items-center justify-center text-white text-lg md:text-xl font-bold leading-relaxed rounded-full h-[40px] w-[40px] p-1 shadow-xl bg-white bg-opacity-5 `}
          >
            {number}
          </div>
        </div>
        {showLine && (
          <div className="lg:w-40 w-[60px] flex-1 bg-customGray-100 h-[2px] bg-opacity-50 rounded-md flex items-center "></div>
        )}
      </div>
      <p className={`font-open-sans font-bold text-white md:text-xl `}>
        {text}
      </p>
    </div>
  );
  return (
    <div
      style={{ backgroundImage: `url(${headerImage})` }}
      className=" w-full bg-no-repeat bg-cover bg-center"
    >
      <Fade up duration={700}>
        <div className="flex flex-col md:flex-row space-y-5 md:space-y-0 px-5 md:px-32 py-4 md:py-10 ">
          <div className="flex flex-1 flex-col">
            <p className="font-poppins text-white font-bold text-3xl md:text-5xl leading-snug">
              Know Your{" "}
              <span className="text-primary-neonGreen">
                Body Better
                {/* <span className="text-white">for free.</span> */}
              </span>
            </p>
          </div>
          <div className="flex flex-row justify-between">
            <Indicator
              className="text-xl font-medium"
              showLine
              text="Select"
              number={1}
            />
            <Indicator
              className="text-xl font-medium"
              showLine
              text="Perform"
              number={2}
            />
            <Indicator
              className="text-xl font-medium"
              text="Get results"
              number={3}
            />
          </div>
        </div>
      </Fade>
    </div>
  );
}

// OTP VERIFICATION
function OtpVerifacation({
  mobile,
  otpVerification,
  sendOtp,
  hash,
  close,
  postCreateLeads,
  fitnessageURL,
  cardioHealthURL,
}) {
  const [otp, setOtp] = useState("");
  const [openFitnessAgeWarning, setOpenFitnessAgeWarning] = useState(false);
  const [openCardioHealthWarning, setOpenCardioHealthWarning] = useState(false);

  async function verifyOtp() {
    if (otp.length != 4) {
      toast("Otp must be 4 characters");
      return;
    }
    let response;
    if (mobile) {
      response = await verifyMobileOtp(mobile, hash, otp);
      console.log(hash);
      if (response.status == 200) {
        setOpenFitnessAgeWarning(true);
        setOpenCardioHealthWarning(true);
        let leadData = {};
        const ipDetails = await getIpDetials();
        if (ipDetails) {
          leadData.user_city = ipDetails.ip;
          leadData.user_city = ipDetails.city;
          leadData.user_state = ipDetails.region;
          leadData.user_country = ipDetails.country;
          leadData.user_calling_code = ipDetails.country_calling_code;
        }
        leadData.first_name = sessionStorage.getItem("first_name") || null;
        leadData.last_name = sessionStorage.getItem("last_name") || null;
        leadData.mobile = sessionStorage.getItem("mobile") || null;
        leadData.dob = sessionStorage.getItem("dob") || null;
        leadData.clicked = sessionStorage.getItem("clicked") || null;

        console.log(leadData);
        await postCreateLead(leadData);
      } else {
        toast("Invalid OTP", { type: "error" });
      }
    }
  }

  useEffect(() => {
    if (!hash) sendOtp();
  }, []);

  return (
    <>
      <WarningPopUpAge
        open={openFitnessAgeWarning}
        close={() => {
          setOpenFitnessAgeWarning(false);
        }}
        onClickNext={fitnessageURL}
      />

      <CustomDialog show={otpVerification} close={close}>
        <Dialog.Panel className="rounded-lg bg-[#0C101B] text-left shadow-xl transition-all md:mx-2 mx-1 md:my-6 my-4 px-10 py-6 sm:my-8 sm:w-full sm:max-w-lg">
          <div className="relative">
            <IconButton
              icon={ic_close}
              className="shadow-xl absolute -top-8 -right-12"
              onClick={() => {
                close();
              }}
            />
            <div className="text-white font-normal text-md font-poppins">
              Verify your mobile number
            </div>
            <OtpInput
              onOtpChanged={(otp) => {
                setOtp(otp);
              }}
            />
            <p
              className="text-primary-gray w-full text-end mt-3 cursor-pointer underline"
              onClick={() => {
                sendOtp();
              }}
            >
              Resend
            </p>
          </div>
          <div className="flex justify-center">
            <Button
              onClick={async () => {
                verifyOtp();
                if (verifyOtp == true) {
                  postCreateLeads();
                  setOpenFitnessAgeWarning(true);
                }
              }}
              type="primary"
              className={"mt-6"}
            >
              Verify
            </Button>
          </div>
        </Dialog.Panel>
      </CustomDialog>
    </>
  );
}

// Pop-up user-details
export function UserDetailsPopUp({
  fitnessAge,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  setMobile,
  setDob,
  mobile,
  dob,
  show,
  close,
  postCreateLeads,
  testType,
  // strechLevel,
}) {
  const [otpVerification, setOtpVerification] = useState(false);
  const [fitnessageURL, setFitnessageURL] = useState("");
  const [cardioHealthURL, setCardioHealthURL] = useState();
  const [quickStrechesURL, setQuickStrechesURL] = useState();
  const [hash, setHash] = useState("");
  const [date, setDate] = useState();

  async function sendOtp() {
    let response;
    if (mobile) {
      response = await sendMobileOtp("+91" + mobile);
      console.log(mobile);
      if (response.status == 200) {
        toast("OTP Sent");
        console.log("send hash :" + response.hash);
        setHash(response.hash);
      }
    }
  }

  // get data from Session Storage
  const first_name = sessionStorage.getItem("firstName");
  const last_name = sessionStorage.getItem("lastName");
  const Use_dob = date;
  const User_mobile = sessionStorage.getItem("mobile");
  console.log("session storage firstName:" + first_name);

  const setURLS = async () => {
    window.dataLayer = window.dataLayer || [];
    (window.dataLayer).push({
      customerFirstName: first_name,
      customerLastName: last_name,
      customerEmail: "",
      cutomerCompanyName: "",
      customerPhone: User_mobile,
      customerBillingAddress1: "",
      customerBillingAddress2: "",
      customerBillingCity: "",
      customerState: "",
      customerBillingPostcode: "",
      customerBillingCountry: "",
      event: "demo_start",
      });
    if (testType == "fitness_age") {
      const formatedDate = date
        .toLocaleString("en-us", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3");
      sessionStorage.setItem("first_name", first_name);
      sessionStorage.setItem("last_name", last_name);
      sessionStorage.setItem("dob", formatedDate);
      sessionStorage.setItem("mobile", User_mobile);
      const fitnessURL = `https://app.getactyvphysio.com/fitnessage?firstName=${first_name}&lastName=${last_name}&dob=${formatedDate}&mobile=${User_mobile}`;

      sessionStorage.setItem("url", fitnessURL);
      setFitnessageURL(fitnessURL);
    } else if (testType == "cardiohealth") {
      const formatedDate = date
        .toLocaleString("en-us", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3");
      const cardioURL = `https://app.getactyvphysio.com/cardiohealth?firstName=${first_name}&lastName=${last_name}&dob=${formatedDate}&mobile=${User_mobile}`;
      sessionStorage.setItem("url", cardioURL);
      setCardioHealthURL(cardioURL);
    } else if (testType == "quick_streches_beginner") {
      const formatedDate = date
        .toLocaleString("en-us", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3");
      const beginnerURL = `https://app.getactyvphysio.com/sample?id=Beginner&firstName=${first_name}&lastName=${last_name}&dob=${formatedDate}&mobile=${User_mobile}`;
      sessionStorage.setItem("url", beginnerURL);
      setQuickStrechesURL(beginnerURL);
    } else if (testType == "quick_streches_intermediate") {
      const formatedDate = date
        .toLocaleString("en-us", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3");
      const intermediateURL = `https://app.getactyvphysio.com/sample?id=Intermediate&firstName=${first_name}&lastName=${last_name}&dob=${formatedDate}&mobile=${User_mobile}`;
      sessionStorage.setItem("url", intermediateURL);
      setQuickStrechesURL(intermediateURL);
    } else if (testType == "quick_streches_advance") {
      const formatedDate = date
        .toLocaleString("en-us", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3");
      const advanceURL = `https://app.getactyvphysio.com/sample?id=Advanced&firstName=${first_name}&lastName=${last_name}&dob=${formatedDate}&mobile=${User_mobile}`;
      sessionStorage.setItem("url", advanceURL);
      setQuickStrechesURL(advanceURL);
    }
  };

  useEffect(() => {
    // this will be called whenever the component is re-rendered
    setFirstName("");
    setLastName("");
    setMobile("");
    setDob("");
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <CustomDialog show={show} close={close}>
        <OtpVerifacation
          mobile={validPhone(mobile) ? "+91" + mobile : null}
          otpVerification={otpVerification}
          sendOtp={() => {
            sendOtp();
          }}
          hash={hash}
          close={close}
          postCreateLeads={() => postCreateLeads()}
          fitnessageURL={fitnessageURL}
        />

        <Dialog.Panel className="rounded-lg bg-[#0C101B] text-left shadow-xl transition-all md:mx-2 mx-1 md:my-6 my-4 px-10 py-6 sm:my-8 sm:w-full sm:max-w-lg">
          <div className="relative">
            <IconButton
              icon={ic_close}
              className="shadow-xl absolute -top-8 -right-12"
              onClick={() => {
                close();
              }}
            />

            <div className="flex flex-col justify-center items-center">
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-4/12 text-white text-lg">
                  First Name*
                </p>
                <input
                  className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                  id="first_name"
                  placeholder="First Name"
                  value={firstName}
                  onChange={(e) => {
                    if (e.target.value == "") {
                      setFirstName("");
                      // toast("Please enter your name");
                    } else if (e.target.value.match(/^[A-Za-z]+$/)) {
                      setFirstName(
                        e.target.value
                          .replace(/[^\w\s\][^,\[\]\^]/gi, "")
                          .replace(/[0-9]/g, "")
                      );
                    }
                  }}
                />
              </div>
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-4/12 text-white text-lg">
                  Last Name*
                </p>
                <input
                  className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                  id="last_name"
                  placeholder="Last Name"
                  value={lastName}
                  onChange={(e) => {
                    if (e.target.value == "") {
                      setLastName("");
                      // toast("Please enter your last name");
                    } else if (e.target.value.match(/^[A-Za-z]+$/)) {
                      setLastName(
                        e.target.value
                          .replace(/[^\w\s\][^,\[\]\^]/gi, "")
                          .replace(/[0-9]/g, "")
                      );
                    }
                  }}
                />
              </div>
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-4/12 text-white text-lg">
                  Mobile*
                </p>
                <input
                  className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                  id="mobile"
                  placeholder="Mobile"
                  value={mobile}
                  onChange={(e) => {
                    // if (e.target.value.length === 0) {
                    //   toast("Please enter your mobile no");
                    // }
                    setMobile(e.target.value);
                  }}
                  maxLength="12"
                  type="number"
                  pattern="[0-9]+"
                />
              </div>
              <div className="flex flex-col md:flex-row mt-5 md:items-center md:space-x-5">
                <p className="font-medium basis-4/12 text-white text-lg">
                  Date of Birth*
                </p>
                <div className="md:w-80">
                  <DatePicker
                    selected={date}
                    onChange={(d) => setDate(d)}
                    dateFormat="dd/MM/yyyy"
                    allowSameDay={false}
                    endDate={new Date()}
                    maxDate={new Date()}
                    placeholderText="Date of Birth"
                    popperPlacement="top-end"
                    closeOnScroll={false}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    id="dob"
                    className="flex flex-1 px-4 w-full h-100% py-3 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700"
                  />
                </div>
              </div>
              <div className="flex justify-end">
                <div
                  className="max-w-max mt-5 text-[#000000] cursor-pointer text-sm font-medium rounded-md bg-primary-neonGreen px-8 py-3"
                  onClick={async () => {
                    if (!firstName && fitnessAge) {
                      toast("First Name is required", { type: "error" });
                    } else if (!lastName && fitnessAge) {
                      toast("Last Name is required", { type: "error" });
                    } else if (!mobile && fitnessAge) {
                      toast("Enter your mobile no", { type: "error" });
                    } else if (!validPhone(mobile) && fitnessAge) {
                      toast("Invalid mobile", { type: "error" });
                    }
                    // else if (!validPhone(mobile) && fitnessAge && mobile) {
                    //   toast("Invalid mobile", { type: "error" });
                    // }
                    else if (!date || date == null || date == " ") {
                      toast("Invalid Date of Birth", { type: "error" });
                    } else {
                      sendOtp();
                      setURLS();
                      setOtpVerification(true);
                    }
                  }}
                >
                  NEXT
                </div>
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </CustomDialog>
      <Transition appear show={true} className="bg-[#1A1B22]">
        <Transition.Child
          // as={Fragment}
          enter="transform transition ease-in-out duration-300"
          leave="transform transition ease-in-out duration-300"
        ></Transition.Child>
      </Transition>
    </>
  );
}

// Fitness-Feature
export function FitnessAgeFeature({ openAuth }) {
  const isMobile = useIsMobile();
  return (
    <div className="w-full px-5 md:px-32 pt-10">
      <Fade up duration={700}>
        <div className="relative flex flex-row overflow-clip bg-[#0B0F19] rounded-lg w-full">
          <div className="absolute top-0 md:left-16 w-80 h-80 rounded-full bg-primary-neonGreen bg-opacity-10"></div>
          <div className="absolute -bottom-20 -right-10 md:right-0 w-80 h-80 rounded-full bg-primary-neonGreen bg-opacity-10"></div>
          <div className="flex flex-col md:flex-row space-y-10 md:space-y-0 items-center rounded-lg px-5 md:px-28 py-8 md:py-20 backdrop-blur-3xl w-full">
            <div className="flex flex-1 flex-col w-full">
              <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
                <span className="text-primary-neonGreen">Fitness </span>
                <br></br>
                Age Test
              </p>
            </div>
            <div className="space-y-1">
              {[
                "An indicator of your strength, mobility and cardio capacity.",
                "Helps identifying your improvement areas.",
                "Recommended exercises, routines, programs to improve your fitness",
              ].map((text) => {
                return (
                  <p className="font-open-sans leading-8 flex flex-row  text-white text-opacity-70">
                    <span className="mt-1 mr-2">
                      <img src={ic_tick} />
                    </span>
                    <span className="flex flex-1">{text}</span>
                  </p>
                );
              })}
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}

// Cardio-Feature
export function CardioHealthFeature({ openAuth }) {
  const isMobile = useIsMobile();
  return (
    <div className="w-full px-5 md:px-32 pt-10">
      <Fade up duration={700}>
        <div className="relative flex flex-row overflow-clip bg-[#0B0F19] rounded-lg w-full">
          <div className="absolute top-0 md:left-16 w-80 h-80 rounded-full bg-primary-neonGreen bg-opacity-10"></div>
          <div className="absolute -bottom-20 -right-10 md:right-0 w-80 h-80 rounded-full bg-primary-neonGreen bg-opacity-10"></div>
          <div className="flex flex-col md:flex-row space-y-10 md:space-y-0 items-center rounded-lg px-5 md:px-28 py-8 md:py-20 backdrop-blur-3xl w-full">
            <div className="flex flex-1 flex-col w-full">
              <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
                <span className="text-primary-neonGreen">Cardio </span>
                <br></br>
                Health Test
              </p>
            </div>
            <div className="space-y-1">
              {[
                "An indicator of your cardiovascular health, stamina and body recovery level.",
                "Helps identify improvement areas.",
                "Recommends verified workouts and plans to strengthen your heart.",
              ].map((text) => {
                return (
                  <p className="font-open-sans leading-8 flex flex-row  text-white text-opacity-70">
                    <span className="mt-1 mr-2">
                      <img src={ic_tick} />
                    </span>
                    <span className="flex flex-1">{text}</span>
                  </p>
                );
              })}
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}

// Quick-Stretches Playlist
function Playlist({
  duration,
  activityImage,
  mainName,
  subName,
  url,
  setShowStartDialog,
  setTestType,
  strechLevel,
  setStrechLevel,
}) {
  // const [showInstructionDialog, setShowInstructionDialog] = useState(false);
  return (
    <>
      {/* <InstructionDialog
        show={showStartDialog}
        close={() => {
          setShowStartDialog(false);
        }}
        allowDontShow={false}
        redirectUrl={url}
      /> */}
      {/* <UserDetailsPopUp /> */}
      <div className="group flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-full min-h-[200px] max-h-full">
        <div
          className="flex flex-1 transform rounded-2xl h-full hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500  w-full"
          onClick={() => {
            setShowStartDialog(true);
            setTestType("quick_streches");
            // setTestType("strechLevel");
          }}
        >
          <div
            style={{ backgroundImage: `url(${activityImage})` }}
            className={` bg-center bg-cover rounded-b-2xl rounded-t-xl w-full h-full flex flex-col`}
          >
            <div
              className={`bg-black-400 bg-opacity-70 rounded-b-2xl rounded-t-xl h-full`}
            >
              <div className="flex flex-col h-full">
                <div className="px-2 pt-8 pb-2 space-y-2 flex flex-1 flex-col  justify-end items-start rounded-xl ">
                  <p
                    className={`font-open-sans text-xs font-medium text-center text-primary-neonGreen italic   `}
                  >
                    EXPERIENCE
                  </p>
                  <p className="font-bold font-open-sans text-white text-lg md:text-xl uppercase">
                    {mainName}
                  </p>
                </div>
                <div
                  className={`px-2 md:px-4 py-1 flex flex-row bg-[#3C4647] items-center rounded-b-xl`}
                >
                  {duration && (
                    <div className="flex items-center gap-x-1">
                      <img src={ic_playlist} />
                      <p className="font-medium text-sm uppercase text-primary-white">
                        {duration} MINUTES
                      </p>
                    </div>
                  )}
                  <div className="flex flex-1"></div>
                  <Icon
                    icon="material-symbols:play-circle"
                    className="text-primary-neonGreen w-7 h-7"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// Warning Pop-up FitnessAge
export function WarningPopUpAge({ open, close, onClickNext }) {
  const [showStartDialog, setShowStartDialog] = useState(false);
  console.log("warning popup 2");
  const url = sessionStorage.getItem("url");
  return (
    <>
      <InstructionDialog
        show={showStartDialog}
        close={() => {
          setShowStartDialog(false);
        }}
        allowDontShow={false}
        redirectUrl={url}
      />
      <CustomDialog show={open} close={close}>
        <Dialog.Panel className="rounded-lg bg-[#0C101B] text-left shadow-xl transition-all md:mx-2 mx-1 md:my-6 my-4 px-10 py-6 sm:my-8 sm:w-full sm:max-w-lg">
          <div className="relative">
            <IconButton
              icon={ic_close}
              className="shadow-xl absolute -top-8 -right-12"
              onClick={() => {
                close();
              }}
            />
            <p className="font-medium text-white  text-md py-4 mx">
              In case of any existing injuries and/or medical condition, kindly
              consult with a certified doctor before starting this evaluation.
            </p>
            <div className="flex justify-center items-center">
              <button
                // className="font-poppins md:text-xl text-md font- md:px-6 md:py-3 rounded-md bg-primary-neonGreen text-[#000000]"
                className="max-w-max mt-5 text-[#000000] cursor-pointer text-sm font-medium rounded-md bg-primary-neonGreen px-8 py-3"
                onClick={() => {
                  // onClickNext();
                  setShowStartDialog(true);
                }}
              >
                Next
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </CustomDialog>
      <Transition appear show={true} className="bg-[#1A1B22]">
        <Transition.Child
          // as={Fragment}
          enter="transform transition ease-in-out duration-300"
          leave="transform transition ease-in-out duration-300"
        ></Transition.Child>
      </Transition>
    </>
  );
}

const WellnessFreeTrial = () => {
  const pathname = window.location.href;
  sessionStorage.setItem("utm_url", pathname);
  const [showAuth, setShowAuth] = useState(false);
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [dob, setDob] = useState();
  const [mobile, setMobile] = useState();
  const [showStartDialog, setShowStartDialog] = useState(false);
  const [testType, setTestType] = useState();
  const [clickedFitnessAge, setClickedFitnessAge] = useState(0);
  const [clickedCardioHealth, setClickedCardioHealth] = useState(0);

  const navigate = useNavigate();
  const isMobile = useIsMobile();

  useEffect(() => {
    // Save the input value to session storage
    sessionStorage.setItem("firstName", firstName);
    sessionStorage.setItem("lastName", lastName);
    sessionStorage.setItem("dob", dob);
    sessionStorage.setItem("mobile", mobile);
    sessionStorage.setItem("clicked", clickedFitnessAge);
    sessionStorage.setItem("clicked", clickedFitnessAge);
  }, [firstName, lastName, dob, mobile]);

  return (
    <>
      <AuthDialog open={showAuth} setOpen={setShowAuth} />
      <UserDetailsPopUp
        fitnessAge={true}
        firstName={firstName}
        setFirstName={setFirstName}
        lastName={lastName}
        setLastName={setLastName}
        setMobile={setMobile}
        setDob={setDob}
        mobile={mobile}
        dob={dob}
        show={showStartDialog}
        testType={testType}
        // strechLevel={strechLevel}
        // close={() => {
        //   setShowStartDialog(false);
        // }}
        close={() => {
          setShowStartDialog(false);
          setFirstName("");
          setLastName("");
          setMobile("");
          setDob("");
        }}
        // onClickNext={(e) => {
        //   loadUserData();
        //   e.preventDefault();
        //   // Clear input fields
        //   setFirstName("");
        //   setLastName("");
        //   setMobile("");
        //   setDob("");
        // }}
      />

      <div className="bg-[#0E0E11]">
        <Header
          openAuth={() => {
            setShowAuth(true);
          }}
        />

        {/* Fitness Age */}
        <div className="w-full px-5 md:px-32 pt-10 md:mt-0 mt-10 rounded-xl hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500">
          <div className="lg:flex-row flex-col">
            <div
              style={{
                backgroundImage: `url(${fitness_age1})`,
                backgroundSize: "cover",
              }}
            >
              <div className="flex md:flex-row flex-col">
                <div className="grid grid-rows-2 gap-2 lg:col-span-2">
                  <p className="md:text-2xl text-xl font-bold text-white font-poppin pt-10 px-10">
                    Find out your{" "}
                    <span className="text-primary-neonGreen">Fitness age</span>
                    <br />
                    <p className="text-white">within 5 mins with 3 exercises</p>
                  </p>
                  <p className="md:text-lg text-sm text-white lg:pt-10 pt-3 lg:pb-0 pb-10 px-10">
                    An indicator of your strength, mobility and cardio capacity
                  </p>
                </div>
                <div className="grid grid-rows-2 sm:grid-rows-1 lg:px-10 px-0">
                  <div className="hidden lg:block"></div>
                  <div className="flex justify-center lg:pb-16">
                    <button
                      className="lg:px-12 lg:py-3 px-8 py-2 rounded-lg bg-primary-neonGreen text-[#000000] text-sm font-medium hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500"
                      onClick={() => {
                        setTestType("fitness_age");
                        setShowStartDialog(true);
                      }}
                    >
                      Start Free Trial
                    </button>
                  </div>
                </div>
                <div className="lg:pt-8 -pt-60  pb-0 flex lg:justify-end justify-center lg:ml-24  h-full">
                  <img src={fitnessAgeImage} alt="image is loading" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Cardio Health */}
        <div className="w-full px-5 md:px-32 pt-10 md:mt-0 mt-2 rounded-xl hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500">
          <div className="lg:flex-row flex-col">
            <div
              style={{
                backgroundImage: `url(${fitness_age1})`,
                backgroundSize: "cover",
              }}
              // className="px-10 py-3  mx-20 my-16"
              // className="lg:px-10 lg:py-3 px-8 lg:pt-6 pb-0 overflow-hidden"
            >
              <div
                // className="grid grid-cols-4 w-full"
                className="flex md:flex-row flex-col"
              >
                <div
                  // className="grid grid-rows-2 lg:gap-2 xl:gap-12 gap-0 col-span-2"
                  className="grid grid-rows-2 gap-2 lg:col-span-2"
                >
                  <p
                    // className="text-3xl font-bold text-white font-poppin pt-10"
                    className="md:text-2xl text-xl font-bold text-white font-poppin pt-10 px-10"
                  >
                    {/* <span className="text-primary-neonGreen">
                      Exercises
                    </span>  */}
                    Find out your{" "}
                    <span className="text-primary-neonGreen">
                      Cardio health
                    </span>
                    <br />
                    {/* <p className="text-white">in under 5 minutes</p> */}
                    <p className="text-white">within 5 mins with 4 exercises</p>
                  </p>
                  <p
                    // className="text-md text-[#757798]  pt-10"
                    className="md:text-lg text-sm text-white lg:pt-10 pt-3 lg:pb-0 pb-10 px-10"
                  >
                    {/* Fill in a simple form and perform four <br />
                    quick exercises to find out your Cardio Health. */}
                    An indicator of your cardiovascular health, stamina and
                    <br /> body recovery level
                  </p>
                </div>
                <div
                  // className="grid md:grid-rows-2 sm:grid-rows-1 lg:gap-20 xl:gap-24 gap-16 pr-10"
                  className="grid grid-rows-2 sm:grid-rows-1 lg:px-10 px-0"
                >
                  <div className="hidden lg:block"></div>
                  <div
                    // className="flex justify-end py-6"
                    className="flex justify-center pb-2 lg:pb-16 lg:pr-4 lg:pl-6"
                  >
                    <button
                      // className="px-16 py-3 rounded-lg bg-primary-neonGreen text-[#000000] text-sm font-medium"
                      className="lg:px-12 lg:py-3 px-8 py-2 rounded-lg bg-primary-neonGreen text-[#000000] text-sm font-medium hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500"
                      onClick={() => {
                        // window.location.href = cardioHealthURL;
                        // setOpenCardioHealthWarning(true);
                        setTestType("cardiohealth");
                        setShowStartDialog(true);
                      }}
                    >
                      Start Free Trial
                    </button>
                  </div>
                </div>
                <div
                  // className="grid align-bottom -mb-5"
                  className="lg:pt-8 -pt-12  pb-0 flex lg:justify-end justify-center lg:ml-24  h-full"
                >
                  <img src={cardioHealth} alt="image is loading" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <QuickStretches /> */}
        <div className="w-full px-5 md:px-32 py-20 -mt-10 hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500">
          <div className="w-full relative flex flex-col bg-primary-lightBlack rounded-xl p-8 ">
            <div className=" flex flex-col justify-center pb-4">
              <p className="font-poppins text-white font-bold md:text-2xl text-xl leading-snug">
                Check your{" "}
                <span className="text-primary-neonGreen">Flexibility </span>{" "}
                with these quick stretches
              </p>
              <p className="md:text-lg text-sm text-[#757798] pt-2 pr-0 items-center">
                {/* Pick any workout */}
              </p>
            </div>
            <div className="w-full grid md:grid-cols-3 grid-cols-1 mt-5 gap-5">
              <div className="group flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-full min-h-[200px] max-h-full">
                <div
                  className="flex flex-1 transform rounded-2xl h-full hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500  w-full"
                  onClick={() => {
                    setShowStartDialog(true);
                    setTestType("quick_streches_beginner");
                  }}
                >
                  <div
                    style={{
                      backgroundImage: `url("https://getactyvfitness.blob.core.windows.net/images/exercises/jumping_jacks.jpg")`,
                    }}
                    className={` bg-center bg-cover rounded-b-2xl rounded-t-xl w-full h-full flex flex-col`}
                  >
                    <div
                      className={`bg-black-400 bg-opacity-70 rounded-b-2xl rounded-t-xl h-full`}
                    >
                      <div className="flex flex-col h-full">
                        <div className="px-2 pt-8 pb-2 space-y-2 flex flex-1 flex-col  justify-end items-start rounded-xl ">
                          <p
                            className={`font-open-sans text-xs font-medium text-center text-primary-neonGreen italic   `}
                          >
                            EXPERIENCE
                          </p>
                          <p className="font-bold font-open-sans text-white text-lg md:text-xl uppercase">
                            Beginner
                          </p>
                        </div>
                        <div
                          className={`px-2 md:px-4 py-1 flex flex-row bg-[#3C4647] items-center rounded-b-xl`}
                        >
                          {3 && (
                            <div className="flex items-center gap-x-1">
                              <img src={ic_playlist} />
                              <p className="font-medium text-sm uppercase text-primary-white">
                                {3} MINUTES
                              </p>
                            </div>
                          )}
                          <div className="flex flex-1"></div>
                          <Icon
                            icon="material-symbols:play-circle"
                            className="text-primary-neonGreen w-7 h-7"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="group flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-full min-h-[200px] max-h-full">
                <div
                  className="flex flex-1 transform rounded-2xl h-full hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500  w-full"
                  onClick={() => {
                    setShowStartDialog(true);
                    setTestType("quick_streches_intermediate");
                  }}
                >
                  <div
                    style={{
                      backgroundImage: `url("https://getactyvfitness.blob.core.windows.net/images/exercises/squats.jpg")`,
                    }}
                    className={` bg-center bg-cover rounded-b-2xl rounded-t-xl w-full h-full flex flex-col`}
                  >
                    <div
                      className={`bg-black-400 bg-opacity-70 rounded-b-2xl rounded-t-xl h-full`}
                    >
                      <div className="flex flex-col h-full">
                        <div className="px-2 pt-8 pb-2 space-y-2 flex flex-1 flex-col  justify-end items-start rounded-xl ">
                          <p
                            className={`font-open-sans text-xs font-medium text-center text-primary-neonGreen italic   `}
                          >
                            EXPERIENCE
                          </p>
                          <p className="font-bold font-open-sans text-white text-lg md:text-xl uppercase">
                            Intermediate
                          </p>
                        </div>
                        <div
                          className={`px-2 md:px-4 py-1 flex flex-row bg-[#3C4647] items-center rounded-b-xl`}
                        >
                          {5 && (
                            <div className="flex items-center gap-x-1">
                              <img src={ic_playlist} />
                              <p className="font-medium text-sm uppercase text-primary-white">
                                {5} MINUTES
                              </p>
                            </div>
                          )}
                          <div className="flex flex-1"></div>
                          <Icon
                            icon="material-symbols:play-circle"
                            className="text-primary-neonGreen w-7 h-7"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="group flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-full min-h-[200px] max-h-full">
                <div
                  className="flex flex-1 transform rounded-2xl h-full hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500  w-full"
                  onClick={() => {
                    setShowStartDialog(true);
                    setTestType("quick_streches_advance");
                  }}
                >
                  <div
                    style={{
                      backgroundImage: `url("https://getactyvfitness.blob.core.windows.net/images/exercises/EX_Bearhold.jpg")`,
                    }}
                    className={` bg-center bg-cover rounded-b-2xl rounded-t-xl w-full h-full flex flex-col`}
                  >
                    <div
                      className={`bg-black-400 bg-opacity-70 rounded-b-2xl rounded-t-xl h-full`}
                    >
                      <div className="flex flex-col h-full">
                        <div className="px-2 pt-8 pb-2 space-y-2 flex flex-1 flex-col  justify-end items-start rounded-xl ">
                          <p
                            className={`font-open-sans text-xs font-medium text-center text-primary-neonGreen italic   `}
                          >
                            EXPERIENCE
                          </p>
                          <p className="font-bold font-open-sans text-white text-lg md:text-xl uppercase">
                            Advanced
                          </p>
                        </div>
                        <div
                          className={`px-2 md:px-4 py-1 flex flex-row bg-[#3C4647] items-center rounded-b-xl`}
                        >
                          {7 && (
                            <div className="flex items-center gap-x-1">
                              <img src={ic_playlist} />
                              <p className="font-medium text-sm uppercase text-primary-white">
                                {7} MINUTES
                              </p>
                            </div>
                          )}
                          <div className="flex flex-1"></div>
                          <Icon
                            icon="material-symbols:play-circle"
                            className="text-primary-neonGreen w-7 h-7"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <HealthyLife
          openAuth={() => {
            setShowAuth(true);
          }}
        /> */}

        <div className="bg-primary-midBlack">
          <div className="w-full px-5 md:px-32 py-5 md:py-10 flex justify-center">
            <Fade up duration={700}>
              <div className="flex flex-col md:flex-row space-y-10 md:space-y-0 items-center mt-10 md:mt-20">
                <p className="font-poppins text-white font-bold text-3xl md:text-5xl leading-snug w-full md:w-1/2 ">
                  The <span className="text-primary-neonGreen">science</span>
                  <br />
                  behind {!isMobile && <br />}
                  every move
                </p>
                <div className="space-y-1">
                  {[
                    // "We care about you, and want your every move to be correct.",
                    // "Our Al-powered immersive trainer provides assistance and ensures your safety at every stage of our workouts.",
                    // "With personalised programs, we want to address your specific goals",
                    // "All we need is your commitment, a smart device,steady internet, and a well-lit room.",
                    "GetActyv's proprietary Perfect Pose Vision tech powers the virtual personal trainer that provides expert guidance",
                    "Real-time feedback, and motivation",
                    "Pushing you to achieve your best",
                  ].map((text) => {
                    return (
                      <p className="font-sans flex flex-row flex-1 text-white leading-8 text-opacity-70">
                        <span className="mr-2 mt-1">
                          <img src={ic_tick} />
                        </span>
                        <span className="flex flex-1">{text}</span>
                      </p>
                    );
                  })}
                  {/* <div className="flex justify-center items-center">
              <img src={perfect_vision_logo} alt="image-loading" />
            </div> */}
                  <img
                    src={perfect_vision_logo}
                    alt="image-loading"
                    className="ml-2"
                  />
                </div>
              </div>
            </Fade>
          </div>
          <TestimonialSection />
          <StartFreeTrail
            openAuth={() => {
              setShowAuth(true);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default WellnessFreeTrial;
